import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { MatTooltipModule } from '@angular/material/tooltip';
import * as packageJson from './../../../../../package.json'

@Component({
  selector: 'msh-footer',
  standalone: true,
  template: `
    <footer class=" text-heavy-copy px-8 py-12 bg-heavy">
      <div class=" max-w-7xl mx-auto">

        <div>
          <a href="/"><img src="96xMobileStorehouse_logo_landscape-reverse.png" 
                  alt="Mobile Warehouse Logo" 
                  class="h-10 mb-3" /></a>
        </div>
        <div class="grid grid-cols-1 md:flex md:gap-12">
          
          <!-- Left Column -->
          <div class="flex grow flex-col space-y-6 mb-4 md:mb-0">
            <div>
              <p class=" text-sm max-w-xs">
                A friendly place to put or find those handy extra&nbsp;items.
              </p>
            </div>

            <div class="flex space-x-4 text-gray-700 ">
              <a href="https://www.facebook.com/profile.php?id=61586601894104" target="_blank" class="hover:text-orange-400 transition-colors duration-700">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" 
                    fill="currentColor" class="w-5 h-5">
                  <path d="M22 12a10 10 0 1 0-11.5 9.9v-7h-2v-3h2v-2.3c0-2 1.2-3.1 3-3.1 
                          .9 0 1.8.1 1.8.1v2h-1c-1 0-1.3.6-1.3 1.2V12h2.3l-.4 3h-1.9v7A10 10 0 0 0 22 12z"/>
                </svg>
              </a>
              <a href="https://x.com/MobileStorehs" target="_blank" class="hover:text-orange-400 transition-colors duration-700">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                    fill="currentColor" class="w-5 h-5">
                  <path d="M18.25 2h3.5l-7.62 8.7L23 22h-6.84l-5.05-6.6L5.4 22H2l8.05-9.18L1.5 2h7.1l4.58 6.08L18.25 2z"/>
                </svg>
              </a>
              <a href="https://youtube.com" target="_blank" class="hover:text-orange-400 transition-colors duration-700">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" 
                    fill="currentColor" class="w-6 h-6">
                  <path d="M19.6 3.2H4.4A3.4 3.4 0 0 0 1 6.6v10.8a3.4 3.4 0 0 0 3.4 3.4h15.2a3.4 3.4 0 0 0 3.4-3.4V6.6a3.4 3.4 0 0 0-3.4-3.4zM10 15.5v-7l6 3.5-6 3.5z"/>
                </svg>
              </a>
            </div>

          </div>

          <!-- Middle Column -->
          <div class="flex flex-col p-y-2">
            @for(link of navLinks; track link){
              <a 
                [routerLink]="encodeLink(link)" 
                class="hover:text-orange-400  transition-colors duration-700">
                {{ link }}
              </a>
            }
          </div>

          <!-- Right Column -->
          <div class="flex flex-col p-y-2">
            @for(link of legalLinks; track link){
              <a
                [routerLink]="encodeLink(link)" 
                class="hover:text-orange-400  transition-colors duration-700">
                {{ link }}
              </a>
            }
          </div>
        </div>
        <div class="text-xs flex justify-between text-navy-700 mt-4">
          <div>© {{ currentYear }} Mobile Storehouse. All rights reserved.</div>
          <div>Version: {{ packageJson.version }}</div>
        </div>
      </div>
    </footer>
  `,
  imports: [RouterLink, MatTooltipModule]
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  packageJson = packageJson;
  navLinks = [
    'About us',
    'Listings',
    'Post a new listing'
  ];

  legalLinks = [
    'Terms of Service',
    'Privacy Policy',
    'Refunds and Returns'
  ];

  encodeLink(label: string): string {
    return '/' + encodeURIComponent(label.replace(/\s+/g, '-').toLowerCase());
  }
}

